import { useEffect, useRef } from "react";

/**
 * Adds the `.in` class to elements with `.fade-up` once they enter the viewport.
 * Lightweight, no animation library dependency.
 *
 * Pass `deps` so the observer re-attaches when async content renders later.
 */
export default function useReveal(deps = []) {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current ?? document;
    const targets = root.querySelectorAll(".fade-up:not(.in)");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" },
    );
    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
}
